import { Edit, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import EditForm from "./EditForm";

const EditExamCommittiee = () => {
  return (
    <Edit
      title="Редактиране на изпитна комисия"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
      transform={({ name, specializationId, year }) => ({
        name,
        specializationId,
        year,
      })}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <EditForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditExamCommittiee;
